<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import VConsole from "./store/vconsole.min.js";
export default {
  name: "app",
  components: {},
  created() {
    if (location.href.indexOf("hemakouyu") != -1) {
      localStorage.setItem("kfphone", "4009933950");
      localStorage.setItem("beiantext", "浙ICP备19040904号-1");
    } else {
      localStorage.setItem("kfphone", "4008888202");
      localStorage.setItem("beiantext", "浙ICP备2021005120号-5");
    }

  },
  mounted() {
    // new VConsole();
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
